import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { loadSettings, saveSettings, getDeviceId } from "@/lib/storage";
import { translations } from "@/i18n/translations";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => loadSettings());
  const deviceId = useMemo(() => getDeviceId(), []);

  useEffect(() => {
    saveSettings(settings);
  }, [settings]);

  const setLang = useCallback((lang) => setSettings((s) => ({ ...s, lang })), []);
  const setSetting = useCallback((k, v) => setSettings((s) => ({ ...s, [k]: v })), []);

  const t = useCallback(
    (key) => (translations[settings.lang] || translations.tr)[key] ?? key,
    [settings.lang]
  );

  const value = { settings, lang: settings.lang, setLang, setSetting, deviceId, t };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
